import styled from "styled-components/macro";

import { motion } from "framer-motion";

export const iPhoneMini = {
  width: 370,
  cssWidth: "370px",
  logoBottom: "calc(128px + ((100% - 128px) / 2))",
  inputPadding: "4px 6px 2px 9px",
};
export const iPhone = {
  width: 412,
  cssWidth: "412px",
  logoBottom: "calc(146px + ((100% - 146px) / 2))",
  inputPadding: "6px 8px 4px 11px",
};

export const Inside = styled.div`
  font-family: Montserrat;
  padding: 24px 32px;
  padding-top: 0;
  //padding-bottom: 42px;
  text-shadow: rgba(0, 0, 0, 0.6) 1px 1px 2px;
  position: relative;
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat;
  font-size: 24px;
  font-variant-numeric: tabular-nums;
  //width: 100%;

  padding: 6px;
  border: 2px solid transparent;
  border-radius: 12px;
  transition: all 250ms ease-in-out;
  &:hover {
    border: 2px solid rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.1);
    cursor: pointer;
  }
`;

export const TogglableInfo = styled(Info)`
  margin-top: 2px;

  &:hover {
    border: ${(p) =>
      p.$isEditing
        ? `2px solid rgba(255, 255, 255, 0.6)`
        : "2px solid transparent"};
    background: ${(p) => (p.$isEditing ? "rgba(255, 255, 255, 0.1)" : "none")};
    cursor: ${(p) => (p.$isEditing ? "pointer" : "inherit")};
  }

  &:focus-within {
    border: ${(p) =>
      p.$isEditing
        ? `2px solid rgba(255, 255, 255, 0.6)`
        : "2px solid transparent"};
    background: ${(p) => (p.$isEditing ? "rgba(255, 255, 255, 0.1)" : "none")};
  }
`;

export const Nickname = styled.div`
  margin-bottom: 8px;
  margin-left: 8px;
`;

export const Number = styled.div`
  width: 100%;
  font-size: 21px;
`;

export const SmallNumber = styled(Number)`
  font-size: 18px;
  height: 24px;
  margin-top: 1px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    font-size: 14px;
    height: 18px;
  }
`;

export const EditButton = styled(motion.button)`
  background: #fff;
  color: #586b74;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  // border-radius: 40px;
  font-size: 22px;
  // position: absolute;
  // right: 16px;
  // top: 50%;
  //margin-top: -26px;
  /* box-shadow: rgba(0, 0, 0, 0.4) 1px 1px 2px; */
  cursor: pointer;

  border-radius: 50%;
  padding: 4px;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.4) 1px 1px 2px;

  &:focus:not(:active) {
    box-shadow: 0 0 0 1px white, inset 0 0 0 2px #182438,
      rgba(0, 0, 0, 0.4) 1px 1px 2px;
  }
`;

export const SmallEditButton = styled(EditButton)`
  width: 34px;
  height: 34px;
`;

export const Label = styled.div`
  font-family: Montserrat;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  text-transform: uppercase;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NumberInput = styled.input`
  appearance: none;
  outline: none;
  border: none;
  padding: 0;
  font-family: Montserrat;
  display: block;
  z-index: 500;
  background: none;
  color: #fff;
  width: 100%;
  font-size: 24px;
  height: 29px;
  font-variant-numeric: tabular-nums;
  text-shadow: rgba(0, 0, 0, 0.5) 1px 1px 2px;

  &::-webkit-input-placeholder,
  &::placeholder {
    color: ${({ useDarkPlaceholder }) =>
      useDarkPlaceholder
        ? "rgba(255, 255, 255, 0.6)"
        : "rgba(255, 255, 255, 0.4)"};
    font-size: 13px;
    text-shadow: ${({ useDarkPlaceholder }) =>
      useDarkPlaceholder ? "rgba(0, 0, 0, 0.8) 0 0 6px" : "none"};
    transform: translateY(-2px);
  }
  @media screen and (max-width: ${iPhone.cssWidth}) {
    font-size: 22px;
    height: 26px;
  }
  @media screen and (max-width: ${iPhoneMini.cssWidth}) {
    font-size: 20px;
    height: 24px;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-text-fill-color: white !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const SmallNumberInput = styled(NumberInput)`
  font-size: 18px;
  height: 24px;
  margin-top: 1px;
  @media screen and (max-width: ${iPhone.cssWidth}) {
    font-size: 14px;
    height: 18px;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 16px;
`;
